<sm-confirm-dialog [displayX]="true">
  <div class="content">
    <mat-form-field appearance="outline" class="label-input no-bottom w-100" floatLabel="always">
      <mat-label>Label</mat-label>
      <input matInput [(ngModel)]="label" placeholder="Credentials label" name="credentials" (keyup.enter)="closeDialog(true)">
    </mat-form-field>
  </div>
</sm-confirm-dialog>
